// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2TR8O","box":"WorkspacesBox_box__1ReBi","node":"WorkspacesBox_node__15oOm"};